import { CardOrder } from 'app/model/CardOrder';
import { StepNames } from 'app/StepNames';

/**
 * Этапы создания заявки, определяющие недозаполненную заявку
 */
const DRAFT_STAGES = [
    'step-get-personal-data',
    StepNames.STEP_PERSONAL_DATA,
    StepNames.STEP_JOB_DATA,
    StepNames.STEP_CHOOSE_PRODUCT_DATA,
];

/**
 * Продолжить можно только последнюю (самую свежую) созданную заявку, у которой (И):
 *
 * продукт совпадает с продуктом текущей заявки,
 * заявка на одном из этапов:
 *  Данные получены из МСИ,
 *  Ввод личных данных,
 *  Ввод сведений о работе,
 *  Выбор параметров продукта.
 *
 * @param orders
 * @param initialOrder
 */
export const getActualDraftOrder = (
    initialOrder: CardOrder,
    orders: CardOrder[] = [],
) => {
    return orders.find(
        ({ stage, cardProductId, cardProductCode }: CardOrder) => {
            const isDataFillStage = DRAFT_STAGES.includes(stage);

            return (
                initialOrder.cardProductCode === cardProductCode &&
                initialOrder.cardProductId === cardProductId &&
                isDataFillStage
            );
        },
    );
};
